// src/components/EMTRouteGuard.tsx
// Route-level guard that prevents employers from accessing EMT onboarding routes.
// Does NOT create profiles. Authed profileless users must still see registration forms.
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function EMTRouteGuard({ children }: { children: React.ReactNode }) {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  if (location.pathname.startsWith('/p/')) {
    return <>{children}</>;
  }

  if (loading) {
    return <div className="p-8 text-center text-[var(--text-secondary)]">Loading…</div>;
  }

  if (!user) {
    return <>{children}</>;
  }

  // Known employer → keep them out of EMT registration
  if (profile?.role === 'employer') {
    if (import.meta.env.DEV) {
      console.log('[GUARD_REDIRECT] EMTRouteGuard => /employer/dashboard from', location.pathname);
      console.trace('[GUARD_REDIRECT_TRACE]');
    }
    return <Navigate to="/employer/dashboard" replace />;
  }

  // No profile yet (or EMT / unknown): render children so registration forms and
  // query redirects (e.g. ?role=employer → /employer-registration) can run.
  // Never hang on "Resolving account…" waiting for a profile that will never appear.
  return <>{children}</>;
}
